// extracted by mini-css-extract-plugin
export default {"account_details":"AccountDetails_account_details__ld1w3"};